export const resources = [
  {
    id: 1,
    title: "Client Experiences",
    description: "Discover how organizations across various sectors have transformed their operations with Voitech Solutions. Read real stories of successful ICT implementations and their impact.",
    filename: "client-experiences.pdf",
    href: "/docs/client-experiences.pdf",
    icon: "Users",
    featured: true
  },
  {
    id: 2,
    title: "Voitech Solutions Profile",
    description: "A comprehensive overview of our company, services, certifications, and partnerships. Learn about our approach to delivering exceptional technological solutions.",
    filename: "voitech-solutions-profile.pdf",
    href: "/docs/voitech-solutions-profile.pdf",
    icon: "FileText",
    featured: true
  },
  {
    id: 3,
    title: "Voitech Digital Brochure",
    description: "Explore our digital brochure showcasing our full range of ICT services, product offerings, and innovative solutions for businesses and communities.",
    filename: "voitech-digital-brochure.pdf",
    href: "/docs/voitech-digital-brochure.pdf",
    icon: "BookOpen",
    featured: false
  }
];
